import { useSelector } from 'react-redux';
import { CreditCardProvider, PaymentMethod } from '../../../__generated__/graphql';
import { selectCartTotals } from '../../App/selectors';
import { useLegacyCartId } from './use-legacy-cart-id';
import { useLegacyCheckoutForm } from './use-legacy-checkout-form';
import type { PurchaseMutationVariables } from '../../../__generated__/graphql';
import type { EmvTransaction } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-types';

export const useCheckoutMapper = () => {
  const form = useLegacyCheckoutForm(); // TODO replace by useContext when/during redux-form migration
  const cartId = useLegacyCartId(); // TODO replace by useSelector when modern reserve is released (or useContext)
  const pricing = useSelector(selectCartTotals);

  const mapToPurchaseRequest = (emvTransaction?: EmvTransaction): PurchaseMutationVariables => {
    let payment;
    if (!cartId) {
      // TODO error handling in next MR
      throw new Error('missing cart id');
    }

    if (emvTransaction) {
      payment = {
        method: PaymentMethod.CreditCard,
        amount: pricing.total.amount,
        creditCard: {
          provider: CreditCardProvider.Tmds,
          tmds: {
            bin: emvTransaction.bin,
            cardType: emvTransaction.paymentDetails.cardType,
            expirationMonth: emvTransaction.expirationMonth,
            expirationYear: emvTransaction.expirationYear,
            hostToken: emvTransaction.hostToken,
            lastFourDigits: emvTransaction.paymentDetails.lastFourDigits,
            merchantReceiptData: emvTransaction.merchantReceiptData,
            nameOnCard: emvTransaction.nameOnCard,
            transactionId: emvTransaction.transactionId,
            token: emvTransaction.token,
          },
        },
      };
    }
    if (form.paymentMethod === 'Other') {
      payment = {
        amount: pricing.total.amount,
        method: PaymentMethod.Other,
        other: {
          name: form.otherPaymentMethod.id,
          value: form.paymentInfo,
        },
      };
    }

    if (!payment) {
      // TODO error handling in next MR
      throw new Error('payment not supported');
    }

    return {
      cartId,
      customer: {
        name: form.fullName,
        email: form.email,
        phone: {
          number: form.phoneNumber,
          prefix: form.phonePre.name,
        },
      },
      payment,
      note: form.paymentNode ?? '',
      linkGlobalAccount: false,
    };
  };

  const mapToDeliveryRequest = (orderId: string) => {
    throw new Error(`modern delivery not implemented yet - orderId: ${orderId}`);
  };

  return { mapToPurchaseRequest, mapToDeliveryRequest };
};
